module.exports = __webpack_public_path__ + "img/6.1205fa5a.jpg";